exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".processar{position:fixed;top:0;left:0;width:100%;height:100%;opacity:.9;background-color:#000;z-index:9999999999999}.processar div{top:36%;left:50%;margin-left:-200px;position:absolute;width:400px;color:#fff;text-align:center;z-index:9999999999999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-309c9013","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/notify/main.vue
// module id = 296
// module chunks = 0